import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { FormLoginType } from '../LoginPage/components/FormLogin';
import { useAsyncCallback } from 'hooks/useAsyncCallback';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { forgotPasswordSchema } from 'utils/validate';
import { forgotPassword } from 'services/auth';
type ForgotPassword = {
  email: string;
};
export const useInjection = () => {
  const navigate = useNavigate();
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm<ForgotPassword>({ resolver: yupResolver(forgotPasswordSchema) });

  const postForgotPassword = useCallback(
    async (data: FormLoginType) => {
      await forgotPassword(data.email);
      navigate(`/forgot-password/success?email=${data.email}`);
    },
    [navigate]
  );

  const navigateLogin = () => navigate('/login');

  const { asyncCallback: handleSubmitForm } = useAsyncCallback(postForgotPassword, []);
  return {
    handleSubmitForm,
    handleSubmit,
    register,
    errors,
    navigateLogin
  };
};
